<div
  class="alert alert-box margin-bottom d-flex"
  [ngClass]="{
    'alert-box-warning': alertType === AlertType.warning,
    'alert-box-info': alertType === AlertType.info,
    'alert-box-error': alertType === AlertType.error,
  }"
  role="alert"
  aria-live="polite"
>
  @if (hasIcon) {
    <div class="me-2">
      @switch (alertType) {
        @case (AlertType.warning) {
          <svg class="alert-warning-icon" viewBox="0 0 16 16" aria-hidden="true">
            <use xlink:href="#exclamation-triangle"></use>
          </svg>
        }
        @case (AlertType.info) {
          <svg class="alert-info-icon" viewBox="0 0 16 16" aria-hidden="true">
            <use xlink:href="#info-circle-fill"></use>
          </svg>
        }
        @case (AlertType.error) {
          <ds-icon
            [icon]="Icons.TriangleExclamation"
            [iconStyle]="IconStyles.Regular"
            [style.color]="EapColors.RedError"
          ></ds-icon>
        }
      }
    </div>
  }
  <div class="ms-2">
    @if (title) {
      <div class="alert-title mb-2">{{ title }}</div>
    }
    <div class="alert-text">{{ text }}</div>
  </div>
  @if (closeable) {
    <div class="ms-auto">
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.XMark"
        (click)="onClose.emit()"
      ></button>
    </div>
  }
</div>
